import { useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Project } from '@/api/client';
import {
  getProjectEntityFromCaches,
  subscribeProjectEntity,
} from '@/lib/projectEntityCache';

export function useProjectEntity(projectId: string, fallback?: Project): Project | undefined {
  const queryClient = useQueryClient();

  return useSyncExternalStore(
    (onStoreChange) => subscribeProjectEntity(queryClient, projectId, onStoreChange),
    () => getProjectEntityFromCaches(queryClient, projectId, fallback),
    () => fallback
  );
}
